export default __webpack_public_path__ + "static/media/financial.fcb4b960.svg";